/* Greylongg V2 home sections (greylongg-shopify-connection, 2026-10-07).
   Loaded by every gl-* section with defer; the guard below makes repeats a no-op.
   Tabs, quick add (Dawn cart notification), wishlist hearts (same localStorage
   format as the theme's product page wishlist), hero first-screen offset, SEO
   read-more. */
(function () {
  "use strict";
  window.GL = window.GL || {};
  if (window.GL.home) return;
  window.GL.home = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Tabs ------------------------------------------------------------------- */
  function initTabs(tablist) {
    if (tablist.dataset.glReady) return;
    tablist.dataset.glReady = "1";
    var tabs = $$("[role=tab]", tablist);
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute("aria-selected", on ? "true" : "false");
          var panel = document.getElementById(t.getAttribute("aria-controls"));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  /* Quick add -------------------------------------------------------------- */
  function sectionsToRender() {
    if ($("#gl-cart-drawer") && window.GL.renderCart) return { el: null, ids: ["gl-cart-drawer"], gl: true };
    var target = $("cart-notification") || $("cart-drawer");
    if (!target) return null;
    if (target.tagName.toLowerCase() === "cart-drawer") return { el: target, ids: ["cart-drawer", "cart-icon-bubble"] };
    return { el: target, ids: ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"] };
  }

  function addToCart(variantId, quick) {
    var target = sectionsToRender();
    var body = new FormData();
    body.append("id", variantId);
    body.append("quantity", "1");
    if (target) {
      body.append("sections", target.ids.join(","));
      body.append("sections_url", window.location.pathname);
    }
    var buttons = $$("button", quick);
    buttons.forEach(function (b) { b.disabled = true; });
    var err = $(".gl-quick-add__error", quick);
    if (err) err.remove();

    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
      body: body
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || "Could not add to cart");
        quick.classList.remove("is-picking");
        if (target && target.gl && res.json.sections) {
          window.GL.renderCart(res.json.sections["gl-cart-drawer"], true);
        } else if (target && typeof target.el.renderContents === "function" && res.json.sections) {
          if (target.el.setActiveElement) target.el.setActiveElement(document.activeElement);
          target.el.renderContents(res.json);
        } else {
          window.location.href = "/cart";
        }
        document.dispatchEvent(new CustomEvent("gl:cart-add", { detail: res.json }));
      })
      .catch(function (e) {
        var p = document.createElement("p");
        p.className = "gl-quick-add__error";
        p.textContent = e.message;
        $(".gl-quick-add__sizes", quick).appendChild(p);
      })
      .then(function () { buttons.forEach(function (b) { b.disabled = false; }); });
  }

  document.addEventListener("click", function (e) {
    var open = e.target.closest(".gl-quick-add__btn");
    if (open) {
      e.preventDefault();
      $$(".gl-quick-add.is-picking").forEach(function (q) { q.classList.remove("is-picking"); });
      var quick = open.closest(".gl-quick-add");
      var sizes = $$(".gl-quick-add__sizes button", quick);
      if (sizes.length === 1 && sizes[0].dataset.variantId) {
        addToCart(sizes[0].dataset.variantId, quick);
      } else {
        quick.classList.add("is-picking");
      }
      return;
    }

    var size = e.target.closest(".gl-quick-add__sizes button[data-variant-id]");
    if (size) {
      e.preventDefault();
      addToCart(size.dataset.variantId, size.closest(".gl-quick-add"));
      return;
    }

    if (!e.target.closest(".gl-quick-add")) {
      $$(".gl-quick-add.is-picking").forEach(function (q) { q.classList.remove("is-picking"); });
    }
  });

  /* Wishlist hearts (theme format: localStorage "wishlist", keyed by title) --- */
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem("wishlist")) || []; } catch (err) { return []; }
  }

  function syncHearts() {
    var titles = readWishlist().map(function (i) { return i.productTitle; });
    $$(".gl-card__wish").forEach(function (btn) {
      var on = titles.indexOf(btn.dataset.productTitle) > -1;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  document.addEventListener("click", function (e) {
    var wish = e.target.closest(".gl-card__wish");
    if (!wish) return;
    e.preventDefault();
    var list = readWishlist();
    var title = wish.dataset.productTitle;
    var has = list.some(function (i) { return i.productTitle === title; });
    if (has) {
      list = list.filter(function (i) { return i.productTitle !== title; });
    } else {
      list.push({
        productTitle: title,
        productImg: wish.dataset.productImg,
        productPrice: wish.dataset.productPrice,
        productUrl: wish.dataset.productUrl
      });
    }
    try { localStorage.setItem("wishlist", JSON.stringify(list)); } catch (err) { /* private mode */ }
    syncHearts();
  });

  /* Hero: fill the first screen under whatever sits above it --------------- */
  function setHeroOffset() {
    $$(".gl-hero--fill").forEach(function (hero) {
      var top = hero.getBoundingClientRect().top + window.scrollY;
      hero.style.setProperty("--gl-hero-offset", Math.max(0, Math.round(top)) + "px");
    });
  }

  /* SEO block ---------------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".gl-seo__toggle");
    if (!toggle) return;
    var text = document.getElementById(toggle.getAttribute("aria-controls"));
    if (!text) return;
    var open = text.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    var label = $("span", toggle);
    if (label) label.textContent = open ? toggle.dataset.less : toggle.dataset.more;
  });

  /* Init (also when the theme editor re-renders a section) ------------------- */
  function init() {
    $$(".gl-tabs[role=tablist]").forEach(initTabs);
    syncHearts();
    setHeroOffset();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.addEventListener("load", setHeroOffset);
  window.addEventListener("resize", setHeroOffset);
  document.addEventListener("shopify:section:load", init);
  window.GL.initHome = init;
})();
